import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import {
  DataTable,
  Column,
  Dropdown,
  InputText,
  MultiSelect,
  iconSet,
  IcomoonReact,
} from "../PrimeReact.js";
import "../../assets/styles/accountant/chartofaccount.scss";
import ItemsService from "../../services/items";
import GV from "../../services/globalVar";
import { SearchOutlined } from "@ant-design/icons";
import { Tooltip, Input, Space } from "antd";
import JournalService from "../../services/journal.js";
import { DatePicker } from "antd";
import { Dropdown as Primedropdown } from "primereact/dropdown";
import moment from "moment";
import { format } from "date-fns";
import GlobalVariable from "../../../../client/src/services/globalVar";
import * as XLSX from "xlsx";
import { Button, Modal } from "antd";
import { Controller, useForm } from "react-hook-form";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";

const Banking = (props) => {
  // const parentData = props;
  const modalref = useRef(null);
  const its = new ItemsService();
  const jor = new JournalService();
    //   useEffect(() => {
    //   return () => {
    //     Object.values(jor.controllers).forEach((c) => c.abort());
    //     jor.controllers = {}; 
    //   };
    // }, []);
  const currency = GV.userDet.tenantConfig.currency;
  const toast = useRef(null);

  const [first1, setFirst1] = useState(0);
  const [tdataLoad, setTdataLoad] = useState(false);
  const [data, setData] = useState([]);
  const [totalRecordsIn, setTotalRecordsIn] = useState(0);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortName, setSortName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [isMounted, setIsMounted] = useState(true);
  const [requestData, setRequestData] = useState([]);
  const [accountSelected, setAccountSelected] = useState("All");
  const [itemId, setItemId] = useState("");
  const { RangePicker } = DatePicker;
  const [passDteRange, setPassDteRange] = useState([]);
  const [bankAccList, setBankAccList] = useState( );
  const [bankListTbl, setBankListTbl] = useState( []);
  const [bankListTblTtl, setBankListTblTtl] = useState(0);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [selectPeriod, setSelectPeriod] = useState("This Month");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [accountType, setAccountType] = useState("Bank");

  const currencyOptions = [
    { label: "INR", value: "INR" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" },
  ];
  const itemStatus = [
    { label: "All Accounts", value: "All", status: true, type: "All" },
    { label: "Active Accounts", value: "Active", status: true, type: "All" },
    {
      label: "Inactive Accounts",
      value: "Inactive",
      status: true,
      type: "All",
    },
    { label: "Custom", value: "Custom", status: true, type: "All" },
  ];

  const items = [
    { label: "This Month", value: "This Month" },
    { label: "Last 3 Month", value: "Last 3 Months" },
    { label: "Last 6 Month", value: "Last 6 Months" },
    { label: "Last 12 Month", value: "Last 12 Months" },
    { label: "This Year", value: "This Year" },
    { label: "Custom", value: "Custom" },
  ];

  const [statusSelected, setStatusSelected] = useState(itemStatus[0].value);
  const [filterSelected, setFilterSelected] = useState(itemStatus[0].value);

  const balances = [
    { label: "Bank Balance", amount: -6855 },
    { label: "Card Balance", amount: 4497 },
    { label: "Cash In Hand", amount: 8605 },
    { label: "Payment Clearing", amount: -9588 },
  ];
  

  const defaultValues = {
    accountName: "",
    accountHolderName:"",
    accountType: "",
    accountcode: "",
    currency: "",
    bankName: "",
    accountNumber: "",
    ifsc: "",
    description: "",
  };

  const {
    register,
    reset,
    control,
    getValues,
    watch,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm({ mode: "onChange", defaultValues });

  const onCustomPage1 = (event) => {
    setFirst1(event.first);
    const val = event.page + 1;
    const size = event.rows;
    setSizePerPage(size);
    setPage(val);
    fetchBankDetails(val, size, searchVal, "", "", "");
  };

  const onCustomPage2 = (event) => {
    setFirst1(event.first);
    const val = event.page + 1;
    const size = event.rows;
    setSizePerPage(size);
    setPage(val);
    GetBankAccountList();
  };
  //sort start
  const [lazyParams, setLazyParams] = useState({
    first: first1,
    rows: sizePerPage,
    page: page,
    sortField: sortName,
    sortOrder: sortOrder,
  });
  const onSort = (event) => {
    setLazyParams(event);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    reset();
  };
  function fetchBankDetails(
    page,
    sizePerPage,
    searchVal,
    sortName,
    sortOrder,
    fromDate,
    toDate,
    peried
  ) {
    // setTdataLoad(true);
    setTdataLoad(true);
    let data = {
      InputParams: {
        TenantID: GV.userDet.tenantDetail.tenantID,
        Period: peried,
        FromDate: fromDate ? fromDate : null,
        ToDate: toDate ? toDate : null,
      },
      ServerSearchables: {
        draw: page,
        searchData: searchVal,
        orderByColumn: sortName,
        orderBy: sortOrder,
        currentPage: page,
        pageSize: sizePerPage,
        pageNumber: page,
      },
    };
    jor
      .GetLedgerBankTransactionListSearch(data)
      .then((res) => {
        setTdataLoad(false);
        if (res.data) {
          setData(res.data.data.ledgerBankList);
          setTotalRecordsIn(res.data.data.serverSearchables.recordsTotal);
        }
      })
      .catch((err) => setTdataLoad(false));
  }
  const GetBankAccountList = () => {
    const datas = {
      "Status": null,
      "TenantID": GV.userDet.tenantDetail.tenantID
    }
    jor.GetBankAccountList(datas).then((res) =>
    {
      setBankListTbl(res.data.data);
      setBankListTblTtl(res.data.data.length);
    }
    )
  }
  const handleDateRange = (dates, dateString) => {
    if (dateString && dateString.length === 2) {
      const startDate = moment(dateString[0]).format("YYYY-MM-DD");
      const endDate = moment(dateString[1]).format("YYYY-MM-DD");
      const dateRangeString = `${startDate} - ${endDate}`;
      setFromDate(startDate);
      setToDate(endDate);
      fetchBankDetails(
        page,
        sizePerPage,
        searchVal,
        "",
        "",
        startDate,
        endDate,
        selectPeriod
      );
      setPassDteRange([dateRangeString]);
    }
  };

  const keySearch = (e) => {
    setSearchVal(e.target.value);
    if (e.key === "Enter") {
      const searched = e.target.value;
      fetchBankDetails(
        1,
        sizePerPage,
        searched,
        sortName,
        sortOrder,
        "",
        "",
        selectPeriod
      );
    }
    if (e.type === "keyup") {
      if (e.target.value === "") {
        fetchBankDetails(
          1,
          sizePerPage,
          "",
          sortName,
          sortOrder,
          "",
          "",
          selectPeriod
        );
      }
    }
  };

  const exportToExcel = () => {
    const fileName = "BRS_Report.xlsx";
    const headerMap = {
      accountCategory: "CATEGORY",
      accountName: "ACCOUNT NAME",
      contactName: "CONTACT NAME",
      transactionDate: "TRANSACTION DATE",
      transactionType: "TRANSACTION TYPE",
      transactionDetails: "TRANSACTION DETAILS",
      referenceNumber: "REFERENCE NUMBER",
      voucherNo: "VOUCHER NO",
      debits: "DEBITS",
      credits: "CREDITS",
    };

    const fieldsToExport = Object.keys(headerMap);
    const filteredData = data.map((item) => {
      const filteredItem = {};
      fieldsToExport.forEach((field) => {
        if (field === "transactionDate" && item[field]) {
          const dateObj = new Date(item[field]);
          filteredItem[headerMap[field]] = dateObj.toISOString().split("T")[0];
        } else {
          filteredItem[headerMap[field]] = item[field];
        }
      });
      return filteredItem;
    });

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const headers = Object.values(headerMap);
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
    ws["!cols"] = headers.map(() => ({ wch: 20 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "BRS Data");
    XLSX.writeFile(wb, fileName);
  };
  const onSubmit = (data) => {
    const datas = {
      "BankAcctID": 0,
      "AccountType": accountType,
      "AccountName": data.accountName,
      "AccountCode": data.accountcode,
      "AccountNumber": data.accountNumber,
      "IFSC": data.ifsc,
      "AccountHolderName": data.accountHolderName,
      "BankName": data.bankName,
      "Balance": 0,
      "IsPrimary": checked,
      "Status": "Active",
      "TenantID": GV.userDet.tenantDetail.tenantID,
      "CreatedOn": format(new Date(), 'yyyy-MM-dd'),
      "CreatedBy": GV.userDet.appUser.firstName + " " +  GV.userDet.appUser.lastName
    }
    jor.SaveBankAccount(datas).then((res) => {
      toast.current.show({
        severity: "success",
        summary: res.data.message,
      });
      GetBankAccountList();
      setAccountType("Bank");
      reset();
    })
  };

  const isShowAddNew = () => {
    setIsModalOpen(true);
  };
  const isChecked = (e) => {
    setChecked(e.target.checked);
  };

  useEffect(() => {
    if (selectPeriod !== "Custom") {
      fetchBankDetails(
        page,
        sizePerPage,
        searchVal,
        "",
        "",
        "",
        "",
        selectPeriod
      );
    }
  }, [selectPeriod]);

  useEffect(() => {
    GetBankAccountList();
  }, [])
  

  return (
    <div>
            <Toast ref={toast} />
      
      <div className="row">
        {isModalOpen ? 
        <div className="col-md-12 ">
          <div className="row mx-2">
            <div className="card card-borderless cc-greyCard-custm mb-3">
              <div className="ms-2 my-2 me-2 ">
                <div className="d-flex justify-content-between flex-wrap align-items-center">
                  <h4 className="m-0">Add Bank / Credit Card</h4>
            
                </div>
              </div>
            </div>
            <div className="col-md-8 ps-0">
              <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
                <div className="row coa-header kk-header-sec">
                  <div className="col-auto header-right ms-auto"></div>
                </div>
                <div className="account-table">
                  <DataTable
                    stripedRows
                    className=""
                    value={bankListTbl}
                    // header={header}
                    // responsiveLayout="scroll"
                    size="small"
                    loading={tdataLoad}
                    paginator
                    lazy
                    totalRecords={bankListTblTtl}
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, bankListTblTtl]}
                    first={first1}
                    rows={sizePerPage}
                    onPage={onCustomPage2}
                    onSort={onSort}
                    sortField={lazyParams.sortField}
                    sortOrder={lazyParams.sortOrder}
                  >
                    <Column
                      field="accountNumber"
                      header="Account Number "
                      style={{width:"20%"}}
                    />
                    <Column field="accountHolderName" header="Account Holder Name " />
                   
                    <Column field="bankName" header="Bank Name" />
                    <Column field="accountName" header="Account Name" />
                    <Column field="accountType" header="Account Type" />
                    {/* <Column field="balance" header="Balance "
                    body={(a) =>
                      GlobalVariable.userDet.tenantConfig.currency +
                      " " +
                      a.balance.toFixed(2)
                    } /> */}
                    
                  </DataTable>
                </div>
              </div>
            </div>
            <div className="col-md-4 p-0">
            <div className="card border-0 mb-2">
            <h4 className="my-2 text-center">Add Bank / Credit Card</h4>

             
            </div>
            <div className="bg-white shadow-sm  h-100 cc-greyCard-custm1">
                <div className="row coa-header kk-header-sec">
                  <div className="col-auto header-right ms-auto"></div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                <div className="m-3 ">
                  <div className="row d-flex align-items-center">
                    <div className="col-md-5 col-sm-5">
                      <label className="">Select Account Type</label>
                    </div>
                    <div className="col-md-7 col-sm-7">
                      <div className="d-flex">
                        <div className="me-3">
                          <RadioButton
                            name="accountType"
                            value="Bank"
                            onChange={(e) => setAccountType(e.value)}
                            checked={accountType === "Bank"}
                          />
                          <label className="ms-2">Bank</label>
                        </div>
                        <div>
                          <RadioButton
                            name="accountType"
                            value="Credit Card"
                            onChange={(e) => setAccountType(e.value)}
                            checked={accountType === "Credit Card"}
                          />
                          <label className="ms-2">Credit Card</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mt-3">
                    <div className="col-md-5 col-sm-5">
                      <label className="required">Account Name</label>
                    </div>
                    <div className="col-md-7 col-sm-7">
                      <input
                        {...register("accountName", { required: true })}
                        className={`form-control p-0 mt-2 w-100 p-1`}
                        style={{ height: "2.2rem" }}
                      />
                      {errors.accountName && (
                        <p className="text-danger text-end mb-0">
                          This field is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mt-3">
                    <div className="col-md-5 col-sm-5">
                      <label className="required">Account Holder Name</label>
                    </div>
                    <div className="col-md-7 col-sm-7">
                      <input
                        {...register("accountHolderName", { required: true })}
                        className={`form-control p-0 mt-2 w-100 p-1`}
                        style={{ height: "2.2rem" }}
                      />
                      {errors.accountHolderName && (
                        <p className="text-danger text-end mb-0">
                          This field is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mt-3">
                    <div className="col-md-5 col-sm-5">
                      <label className="">Account Code</label>
                    </div>
                    <div className="col-md-7 col-sm-7">
                      <input
                        type="text"
                        {...register("accountcode", { required: false })}
                        className={`form-control p-0 mt-2 w-100 p-1`}
                        style={{ height: "2.2rem" }}
                      />
                    </div>
                  </div>
                  {/* <div className="row d-flex align-items-center mt-3">
              <div className="col-md-6 col-sm-6">
                <label className="">Currency</label>
              </div>
              <div className="col-md-6 col-sm-6">
                <Dropdown
                  options={currencyOptions}
                  {...register("currency", { required: "Currency is required" })}
                  className="w-100"
                />
                {errors.currency && (
                  <p className="text-danger text-end mb-0">
                    {errors.currency.message}
                  </p>
                )}
              </div>
            </div> */}
                  <div className="row d-flex align-items-center mt-3">
                    <div className="col-md-5 col-sm-5">
                      <label>Bank Name</label>
                    </div>
                    <div className="col-md-7 col-sm-7">
                      <input
                        type="text"
                        {...register("bankName")}
                        className="form-control p-0 mt-2 w-100 p-1"
                      />
                    </div>
                  </div>
                      <div className="row d-flex align-items-center mt-3">
                        <div className="col-md-5 col-sm-5">
                          <label>Account Number</label>
                        </div>
                        <div className="col-md-7 col-sm-7">
                          <input
                            type="text"
                            {...register("accountNumber")}
                            className="form-control p-0 mt-2 w-100 p-1"
                          />
                        </div>
                      </div>
                  {accountType === "Bank" && (
                    <>
                      <div className="row d-flex align-items-center mt-3">
                        <div className="col-md-5 col-sm-5">
                          <label>IFSC Code</label>
                        </div>
                        <div className="col-md-7 col-sm-7">
                          <input
                            type="text"
                            {...register("ifsc")}
                            className="form-control p-0 mt-2 w-100 p-1"
                          />
                        </div>
                      </div>
                      <div className="row d-flex align-items-center mt-3">
                    <div className="col-md-5 col-sm-5">
                    </div>
                    <div className="col-md-7 col-sm-7">
                     <input type="checkbox" onClick={(e) => isChecked(e)}/> <label htmlFor="">Make this primary</label>
                    </div>
                  </div>
                    </>
                  )}
                  {/* <div className="row d-flex align-items-center mt-3">
                    <div className="col-md-5 col-sm-5">
                      <label>Description</label>
                    </div>
                    <div className="col-md-7 col-sm-7">
                      <InputTextarea
                        {...register("description")}
                        className="form-control p-0 mt-2 w-100 p-1"
                        rows={5}
                        cols={30}
                      />
                    </div>
                  </div> */}
                  
                </div>
                <div className="d-flex me-3 justify-content-end">
                  <button type="submit"
                                className="btn btn-primary mx-3"> Save </button>
                  <button  className="btn btn-danger "
                                type="button" onClick={() => setIsModalOpen(false)}
                                > Cancel</button>
                </div>
            
              </form>
              </div>
            
            </div>
          </div>
        </div> : 
         <div className="col-md-12">
          <div className="card card-borderless cc-greyCard-custm mb-3">
            <div className="ms-2 my-2 me-2 ">
              <div className="d-flex justify-content-between flex-wrap align-items-center">
                <h4 className="m-0">Banking Summary</h4>
                <div className="d-flex justify-content-end text-t-primary kk-table-header kk-header-sec  cc-font-size-14">
                  <div className="col">
                    {/* <Dropdown
                      className="col-auto text-start me-3"
                      value={filterSelected}
                      options={itemStatus}
                      // onChange={(e) => accountChange(e)}
                      scrollHeight="400px"
                      placeholder="Select account"
                    /> */}

                    <Space.Compact className="my-auto mx-2">
                      <Input
                        addonBefore={<SearchOutlined />}
                        allowClear
                        placeholder="Search"
                        value={searchVal}
                        onChange={(e) => keySearch(e)}
                        onKeyUp={(e) => keySearch(e)}
                      />
                    </Space.Compact>

                    <Primedropdown
                      value={selectPeriod}
                      onChange={(e) => {
                        setSelectPeriod(e.value);
                      }}
                      options={items}
                      optionLabel="label"
                      placeholder="Select status to filter"
                      className="col-auto text-start me-3 my-auto"
                    />

                    {selectPeriod === "Custom" && (
                      <Space
                        direction="vertical"
                        className="col-auto mx-3"
                        size={12}
                      >
                        <RangePicker onChange={handleDateRange} picker="date" />
                      </Space>
                    )}
                    <button
                      className="btn btn-primary py-1 me-2 kk-btnThin my-2"
                      style={{
                        // backgroundColor: "#dddddd",
                        border: "none",
                        color: "black !important",
                      }}
                      onClick={exportToExcel}
                    >
                      {" "}
                      Export
                    </button>

                    <button
                      className="btn btn-primary py-1 me-2 kk-btnThin my-2"
                      onClick={() => {isShowAddNew(true); 
      setAccountType("Bank");

                      }}
                      style={{
                        // backgroundColor: "#dddddd",
                        border: "none",
                        color: "black !important",
                      }}
                    >
                      {" "}
                      Add Bank or Credit Card
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
            <div className="row coa-header kk-header-sec">
              <div className="col-auto header-right ms-auto"></div>
            </div>
            <div className="account-table ">
              <DataTable
                stripedRows
                className=""
                value={data}
                // header={header}
                // responsiveLayout="scroll"
                size="small"
                loading={tdataLoad}
                paginator
                lazy
                totalRecords={totalRecordsIn}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                rowsPerPageOptions={[10, 20, 50, totalRecordsIn]}
                first={first1}
                rows={sizePerPage}
                onPage={onCustomPage1}
                onSort={onSort}
                sortField={lazyParams.sortField}
                sortOrder={lazyParams.sortOrder}
              >
                <Column
                  field="transactionDate"
                  header="Transcation Date"
                  body={(row) => (
                    <div>
                      {" "}
                      {format(
                        new Date(row.transactionDate),
                        GV.userDet.tenantConfig.dateFormat
                      )}
                    </div>
                  )}
                />
                <Column field="transactionType" header="Transaction Type" />
                <Column
                  field="transactionDetails"
                  header="Transaction Details " body={(a) => a.transactionDetails ? a.transactionDetails : "-"}
                />
                <Column field="voucherNo" header="Voucher No" />
                <Column field="contactName" header="Contact Name" />
                <Column field="accountName" header="Account Name" />
                <Column field="accountCategory" header="Account Category" />
                <Column
                  field="debits"
                  className="text-end amount-align"
                  body={(a) =>
                    GlobalVariable.userDet.tenantConfig.currency +
                    " " +
                    a.debits.toFixed(2)
                  }
                  header="Debits"
                />
                <Column
                  field="credits"
                  className="text-end amount-align"
                  body={(a) =>
                    GlobalVariable.userDet.tenantConfig.currency +
                    " " +
                    a.credits.toFixed(2)
                  }
                  header="Credits"
                />
              </DataTable>
            </div>
          </div>
        </div>}
      </div>
       
        
      <Modal
        title="Add New Account"
        // open={isModalOpen}
        onOk={handleSubmit((data) => onSubmit(data))}
        onCancel={handleCancel}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mt-3 ">
            <div className="row d-flex align-items-center">
              <div className="col-md-6 col-sm-6">
                <label className="">Select Account Type</label>
              </div>
              <div className="col-md-6 col-sm-6">
                <div className="d-flex">
                  <div className="me-3">
                    <RadioButton
                      name="accountType"
                      value="Bank"
                      onChange={(e) => setAccountType(e.value)}
                      checked={accountType === "Bank"}
                    />
                    <label className="ms-2">Bank</label>
                  </div>
                  <div>
                    <RadioButton
                      name="accountType"
                      value="Credit Card"
                      onChange={(e) => setAccountType(e.value)}
                      checked={accountType === "Credit Card"}
                    />
                    <label className="ms-2">Credit Card</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center mt-3">
              <div className="col-md-6 col-sm-6">
                <label className="required">Account Name</label>
              </div>
              <div className="col-md-6 col-sm-6">
                <input
                  {...register("accountName", { required: true })}
                  className={`form-control p-0 mt-2 w-100 p-1`}
                  style={{ height: "2.2rem" }}
                />
                {errors.accountName && (
                  <p className="text-danger text-end mb-0">
                    This field is required
                  </p>
                )}
              </div>
            </div>
            <div className="row d-flex align-items-center mt-3">
              <div className="col-md-6 col-sm-6">
                <label className="">Account Code</label>
              </div>
              <div className="col-md-6 col-sm-6">
                <input
                  type="text"
                  {...register("accountcode", { required: false })}
                  className={`form-control p-0 mt-2 w-100 p-1`}
                  style={{ height: "2.2rem" }}
                />
              </div>
            </div>
            {/* <div className="row d-flex align-items-center mt-3">
            <div className="col-md-6 col-sm-6">
              <label className="">Currency</label>
            </div>
            <div className="col-md-6 col-sm-6">
              <Dropdown
                options={currencyOptions}
                {...register("currency", { required: "Currency is required" })}
                className="w-100"
              />
              {errors.currency && (
                <p className="text-danger text-end mb-0">
                  {errors.currency.message}
                </p>
              )}
            </div>
          </div> */}

            <div className="row d-flex align-items-center mt-3">
              <div className="col-md-6 col-sm-6">
                <label>Bank Name</label>
              </div>
              <div className="col-md-6 col-sm-6">
                <input
                  type="text"
                  {...register("bankName")}
                  className="form-control p-0 mt-2 w-100 p-1"
                />
              </div>
            </div>
            {accountType === "Bank" && (
              <>
                <div className="row d-flex align-items-center mt-3">
                  <div className="col-md-6 col-sm-6">
                    <label>Account Number</label>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <input
                      type="text"
                      {...register("accountNumber")}
                      className="form-control p-0 mt-2 w-100 p-1"
                    />
                  </div>
                </div>

                <div className="row d-flex align-items-center mt-3">
                  <div className="col-md-6 col-sm-6">
                    <label>IFSC Code</label>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <input
                      type="text"
                      {...register("ifsc")}
                      className="form-control p-0 mt-2 w-100 p-1"
                    />
                  </div>
                </div>
              </>
            )}
            <div className="row d-flex align-items-center mt-3">
              <div className="col-md-6 col-sm-6">
                <label>Description</label>
              </div>
              <div className="col-md-6 col-sm-6">
                <InputTextarea
                  {...register("description")}
                  className="form-control p-0 mt-2 w-100 p-1"
                  rows={5}
                  cols={30}
                />
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Banking;
